module.exports = __webpack_public_path__ + "img/fajg.447c5a4f.png";